import React from 'react'
import { Button, Tooltip } from 'antd'
import styled from 'styled-components'

const Btn = (props) => {
  let {
    loading = false, onClick,
    text = 'Click', title = 'Click'
  } = props

  let content
  let click
  if (loading === false) {
    content = text
    click = onClick
  }
  return (
    <Page>
      <Tooltip placement="top" title={title}>
        <Button shape="circle" loading={loading} onClick={click}>
          {content}
        </Button>
      </Tooltip>
    </Page>
  )
}

const Page = styled.div`
  text-align: center;
  button {
    color: #404040;
    background-color: white;
    height: 50px
    width: 50px;
    font-size: 12px;
  }

  button:hover {
    color: white;
    background-color: #404040;
    border-color: white;
  }
`

export default Btn
